/**
 * client/camera/deathcam.ts — keep the third-person death camera out of walls (pure, no THREE).
 *
 * OWNER: VIEWMODEL+CAMERA agent. Port of the Q3/IW CG_OffsetThirdPersonView wall check (cg_view.c): an 8x8x8 box
 * (mins -4, maxs 4, "to prevent the view from near clipping anything") is swept from the focus point to the
 * desired camera position against MASK_SOLID; on a hit the camera goes to the end position, is raised by
 * (1 - fraction) * 32 and swept once more. T6's ThirdPersonViewTrace is not in research/ (ESTIMATE: same rule).
 */
import type { Vec3 } from '@shared/math';
import { CONTENTS, createTraceResult, type CollisionWorld } from '@shared/collision/types';

const MINS: Vec3 = [-4, -4, -4];
const MAXS: Vec3 = [4, 4, 4];
/** Q3 MASK_SOLID. */
const MASK_SOLID = CONTENTS.SOLID;
const tr = createTraceResult();
const tmp: Vec3 = [0, 0, 0];

/** Pull `view` (in/out) toward `focus` so the box does not sit inside or behind world geometry. */
export function thirdPersonViewTrace(world: CollisionWorld | null, focus: Readonly<Vec3>, view: Vec3): void {
  if (!world) return;
  world.trace(tr, focus, view, MINS, MAXS, MASK_SOLID);
  if (tr.fraction >= 1) return;
  tmp[0] = tr.endpos[0]; tmp[1] = tr.endpos[1]; tmp[2] = tr.endpos[2] + (1 - tr.fraction) * 32;
  world.trace(tr, focus, tmp, MINS, MAXS, MASK_SOLID);
  view[0] = tr.endpos[0]; view[1] = tr.endpos[1]; view[2] = tr.endpos[2];
}
